import React, { useEffect, useState } from "react";
import { MdAdd, MdClose, MdDelete, MdEdit, MdVisibility } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import api from "../../../services/api";
import {
  Card,
  HeaderTitle,
  ViewInput,
  Table,
  Scroll,
  Message,
} from "../../../GlobalStyles";
import { toast } from "react-toastify";
import { Button, Modal, Input, Pagination, Select, Spin } from "antd";
import { Container } from "./styles";
import { format } from "date-fns";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";

import { ExclamationCircleFilled } from "@ant-design/icons";
const { TextArea } = Input;
const { confirm } = Modal;

dayjs.extend(weekday);
dayjs.extend(localeData);

const Comunicados = () => {
  const navigate = useNavigate();

  const [statements, setStatements] = useState([]);
  const [statementsTotal, setStatementsTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [page, setPage] = useState(0);
  const [id, setId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState("");
  const [users, setUsers] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    loadStatements(page);
  }, [page]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadStatements(page) {
    await api
      .get(`/statements?page=${page}`)
      .then((response) => {
        setStatements(response.data.statements);
        setStatementsTotal(response.data.statementsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createStatement() {
    setIsLoadingModal(true);
    if (!title || !description) {
      toast.warn("Preencha o titulo e descrição para salvar comunicado");
    } else {
      if (id) {
        await api
          .put(`/statement/${id}`, {
            title: title,
            description: description,
          })
          .then((response) => {
            toast.success("Comunicado editado com sucesso");
            loadStatements(page);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      } else {
        await api
          .post(`/statement`, {
            title: title,
            description: description,
          })
          .then((response) => {
            toast.success("Comunicado criado com sucesso");
            loadStatements(page);
            setIsOpen(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteStatement(statement) {
    await api
      .delete(`/statement/${statement.id}`)
      .then(() => {
        toast.success("Comunicado deletado com sucesso");
        loadStatements(page);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }
  return (
    <Container>
      <HeaderTitle>
        <h1>Comunicados</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            setId("");
            setTitle("");
            setDescription("");
            setIsOpen(true);
          }}
        >
          <MdAdd size="20" color="#fff" />
          <span>Criar Comunicado</span>
        </Button>
      </HeaderTitle>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={statementsTotal} separator="." />
      </Card>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ViewInput style={{ width: "100%", maxWidth: 300, marginRight: 15 }}>
          <p>Filtrar por Franqueado</p>
          <Select
            placeholder="selecionar franqueado"
            value={user}
            showSearch
            optionFilterProp="children"
            style={{ width: "100%", textAlign: "left" }}
            onChange={(value) => {
              setUser(value);
              setPage(0);
            }}
          >
            <Select.Option value={""}>Todos Franqueados</Select.Option>
            {users.map((item) => {
              return <Select.Option value={item.id}>{item.name}</Select.Option>;
            })}
          </Select>
        </ViewInput>
      </div>
      {!isLoading && (
        <>
          {statements?.length ? (
            <>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td>Titulo</td>
                      <td style={{ minWidth: 250 }}>Descrição</td>
                      <td>Presença</td>
                      <td>Criado</td>
                      <td style={{ width: 80 }}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {statements.map((statement) => (
                      <tr key={statement.id}>
                        <td>{statement.title}</td>
                        <td>{statement.description}</td>
                        <td>
                          {user
                            ? statement.statement_confirms.some(
                                (item) => user == item.user_id
                              )
                              ? "Confirmado"
                              : "Pendente"
                            : `${statement.statement_confirms.length}/${users.length} confirmados`}
                        </td>
                        <td>
                          {format(
                            new Date(statement.create_at),
                            "dd/MM/yyyy HH:mm"
                          )}
                        </td>
                        <td style={{ width: 160 }}>
                          <div
                            style={{
                              display: "flex",
                              cursor: "pointer",
                              alignItems: "center",
                              justifyContent: "flex-end",
                            }}
                          >
                            <MdVisibility
                              onClick={() => {
                                navigate(`/admin/comunicado/${statement.id}`);
                              }}
                              style={{ cursor: "pointer", marginLeft: 8 }}
                              size={18}
                              color={"#001B22"}
                            />
                            <MdEdit
                              onClick={() => {
                                setId(statement.id);
                                setTitle(statement.title);
                                setDescription(statement.description);
                                setIsOpen(true);
                              }}
                              style={{ cursor: "pointer", marginLeft: 8 }}
                              size={18}
                              color={"#001B22"}
                            />
                            <MdDelete
                              onClick={() => {
                                confirm({
                                  okText: "Confirmar",
                                  title: "Deseja excluir o Comunicado?",
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após essa ação, o Comunicado ${statement.title} será excluido.`,
                                  onOk() {
                                    deleteStatement(statement);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{ cursor: "pointer", marginLeft: 8 }}
                              size={18}
                              color={"#001B22"}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scroll>
              <Pagination
                style={{
                  margin: "25px 0",
                  alignSelf: "center",
                }}
                defaultCurrent={page + 1}
                onChange={(page) => {
                  setPage(page - 1);
                }}
                total={statementsTotal}
                pageSize={30}
                showTotal={(total) => `${total} comunicados`}
              />
            </>
          ) : (
            <Message>Nenhum comunicado encontrado</Message>
          )}
        </>
      )}

      {isLoading && <Spin size="large" style={{ marginTop: 50 }} />}

      <Modal
        title={id ? "Editando comunicado" : "Cadastrando um novo comunicado"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "Editar" : "Cadastrar"}
        cancelText="Cancelar"
        onOk={() => {
          createStatement();
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <ViewInput>
          <p>Titulo*</p>
          <Input
            placeholder="titulo"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </ViewInput>
        <ViewInput>
          <p>Descrição</p>
          <TextArea
            style={{ minHeight: 60 }}
            placeholder="descrição"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </ViewInput>
      </Modal>
    </Container>
  );
};

export default Comunicados;
